module.exports = __webpack_public_path__ + "static/media/Step 10c-Cartographer.5ab82952.png";